import React, { useEffect, useState } from "react";
import { TimeEvent } from "../../types/employee";
import dayjs from "dayjs";


type UserTimeEntryMap = {
    [date: string]: {
        events: TimeEvent[];
        minutesWorked: number;
    };
}

type MyHoursProps = {
    workBreakdown: UserTimeEntryMap;
}

export const MyHours: React.FC<MyHoursProps> = ({ workBreakdown }) => {

    const [regularMinutes, setRegularMinutes] = useState(0);
    const [overtimeMinutes, setOvertimeMinutes] = useState(0);

    const getLocalDate = (dateStr: string) => {
        const [year, month, day] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day); // month is 0-indexed
    };

    useEffect(() => {
        function calculateOvertime(dailyBreakdown: { [date: string]: number } | null | undefined) {
            let totalRegular = 0;
            let totalOvertime = 0;

            if (!dailyBreakdown || Object.keys(dailyBreakdown).length === 0) {
                return {
                    totalMinutes: 0,
                    regularMinutes: 0,
                    overtimeMinutes: 0,
                };
            }

            // Group daily totals into weeks
            const weeklyTotals: Record<string, number> = {};

            for (const date of Object.keys(dailyBreakdown)) {
                const minutes = dailyBreakdown[date] || 0; // handle missing values
                const weekStart = dayjs(date).startOf("week").format("YYYY-MM-DD");

                if (!weeklyTotals[weekStart]) weeklyTotals[weekStart] = 0;
                weeklyTotals[weekStart] += minutes;
            }

            // Apply weekly cap logic
            for (const weekStart of Object.keys(weeklyTotals)) {
                const minutes = weeklyTotals[weekStart];

                if (minutes > 2400) {
                    totalRegular += 2400;
                    totalOvertime += minutes - 2400;
                } else {
                    totalRegular += minutes;
                }
            }
            setRegularMinutes(totalRegular);
            setOvertimeMinutes(totalOvertime);
        }

        calculateOvertime(
            Object.fromEntries(
                Object.entries(workBreakdown).map(([date, data]) => [date, data.minutesWorked])
            )
        );
    }, [workBreakdown]);

    return (
        <div className="my-hours-container">
            <div className="panel-header">
                <h2>Total Hours Worked</h2>
                <span className="status clocked-in">Reg: {(regularMinutes / 60).toFixed(2)} Ot: {(overtimeMinutes / 60).toFixed(2)}</span>
            </div>
            <main>
                <section className="hours-section">
                    <ul className="hours-list">
                        {Object.entries(workBreakdown).map(([date, { minutesWorked }]) => {
                            const dateObj = getLocalDate(date);
                            const formattedDate = dateObj.toLocaleDateString("en-US", {
                                weekday: "short",
                                month: "short",
                                day: "numeric",
                            });

                            return (
                                <li key={date}>
                                    {formattedDate} - {(minutesWorked / 60).toFixed(2)} hours
                                </li>
                            );
                        })}
                    </ul>

                </section>
            </main>

        </div>
    );
};

require("./styles.scss");
